import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

const CaseStudiesSection = ({ caseStudies }) => {
  if (!caseStudies?.length) return null;
  return (
    <section className="section-padding bg-[#0A0A0A]" data-testid="case-studies-section">
      <div className="container-custom">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#00E676] uppercase tracking-wider text-sm font-medium">Results</span>
          <h2 className="text-4xl md:text-5xl font-bold mt-4 mb-6">
            Dallas Success Stories
          </h2>
          <p className="text-gray-400 text-lg">
            Real results for real Dallas businesses. See how we&apos;ve helped local companies dominate search.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {caseStudies.slice(0, 4).map((study) => (
            <Card 
              key={`${study.id}-${study.slug}`}
              className="bg-[#050505] border-white/5 hover:border-[#00E676]/30 transition-all overflow-hidden"
              data-testid={`case-study-${study.id}`}
            >
              <div className="relative h-48">
                <img 
                  src={study.image || study.featured_image}
                  alt={study.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#050505] to-transparent" />
                <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-[#00E676]/20 text-[#00E676] text-sm">
                  {study.industry}
                </span>
              </div>
              <CardContent className="p-6">
                <h3 className="text-xl font-bold mb-3">{study.title}</h3>
                {Array.isArray(study.results) ? (
                  <ul className="space-y-2 mb-4">
                    {study.results.slice(0, 3).map((item, i) => (
                      <li key={i} className="flex items-start gap-2 text-sm text-gray-300">
                        <span className="text-[#00E676] mt-0.5">✓</span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <div className="grid grid-cols-2 gap-4 mb-4">
                    {Object.entries(study.results || study.metrics || {}).slice(0, 4).map(([key, value]) => (
                      <div key={key} className="text-center p-3 rounded-lg bg-white/5">
                        <p className="text-[#00E676] font-bold text-xl">{value}</p>
                        <p className="text-gray-500 text-xs capitalize">{key.replace('_', ' ')}</p>
                      </div>
                    ))}
                  </div>
                )}
                <Link to={`/case-studies/${study.slug}`}>
                  <Button variant="ghost" className="text-[#00E676] hover:text-[#00C853] p-0">
                    Read Full Case Study <ChevronRight className="w-4 h-4 ml-1" />
                  </Button>
                </Link>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/case-studies">
            <Button className="btn-outline" data-testid="view-all-case-studies">
              View All Case Studies
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CaseStudiesSection;
